import allUrls from '@/utils/config'
import gjUtmConfig from '@/utils/gjUtm'
import nav from "@/modules/config/nav"

const shareList = [
  {
    name: 'wechat',
    tips: 'common.media.wechat',
    image: '~/assets/img/icons/wx.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_wechat.jpg',
  },
  {
    name: 'weibo',
    tips: 'common.media.weibo',
    image: '~/assets/img/icons/weibo.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_weibo.png',
  },
  {
    name: 'douyin',
    tips: 'common.media.douyin',
    image: '~/assets/img/icons/douyin.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_tiktok.png',
  },
  // {
  //   name: 'lingying',
  //   image: '~/assets/img/icons/lingyin.svg',
  //   qrcode: '~/assets/img/footer/ic_qrcode_lingying.png',
  // },
  {
    name: 'facebook',
    tips: 'common.media.facebook',
    image: '~/assets/img/icons/facebook.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_facebook.png',
  },
  // {
  //   name: 'tw',
  //   image: require('~/assets/img/icons/tw.png'),
  //   qrcode: '~/assets/img/footer/ic_qrcode_tw.png',
  // },
  {
    name: 'youbube',
    tips: 'common.media.youtube',
    image: '~/assets/img/icons/youbube.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_youbute.png',
  },
  {
    name: 'ins',
    tips: 'common.media.instagram',
    image: '~/assets/img/icons/ins.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_ins.png',
  },
  {
    name: 'tiktok',
    tips: 'common.media.tiktok',
    image: '~/assets/img/icons/douyin.svg',
    qrcode: '~/assets/img/footer/ic_qrcode_tiktok.png',
  },
]

const config = {
  cn: {
    shareList: shareList,
    shareSubList: [],
    service: {
      product: [
        {
          tel: '95338',
          telephone: '95338',
          list: [
            'modules.logisticsService.productList.fast', // 国际标快
            'modules.logisticsService.productList.discts', // 国际特惠
          ],
          time: ['relation.expressTime'],
        },
        {
          list: [
            'modules.logisticsService.productList.parcel', // 国际小包
            'modules.logisticsService.productList.delivery', // 国际电商专递
          ],
          time: ['relation.OfficeTime9_20'], // 营业时间
        },
        {
          list: [
            'modules.logisticsService.productList.warehouse', // 海外仓
          ],
          time: ['relation.OfficeTime9_18'], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.cn,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuoploginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
            href: allUrls.klnUrl + '/' + lang,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.Ezhou', // 顺丰鄂州国际货站
            href: allUrls.ezhou,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.fengtuPlatform', // 丰图科技开放平台
            href: allUrls.fengtuUrl,
          },
        ]
      },
      customerUrl: allUrls.iuopCustomerUrl, // 商务合作
    },
  },
  sg: {
    shareList: shareList,
    shareSubTitle: 'modules.about.homePageTitles.followSg',
    shareSubList: [
      {
        name: 'sg_whatsApp',
        tips: 'common.media.whatsApp',
        image: '~/assets/img/icons/whatsapp.png',
        // qrcode: '~/assets/img/footer/sg_qrcode_whatsapp.png',
        link: 'https://wa.link/ypa91t',
      },
      {
        name: 'sg_facebook',
        tips: 'common.media.facebook',
        image: '~/assets/img/icons/facebook.svg',
        link: 'https://www.facebook.com/profile.php?id=61553079237157',
      },
      {
        name: 'my_ins',
        tips: 'common.media.instagram',
        image: '~/assets/img/icons/ins.svg',
        // qrcode: '~/assets/img/footer/my_qrcode_ins.png',
        link: 'https://www.instagram.com/sfexpress_singapore/',
      },
      {
        name: 'tiktok',
        tips: 'common.media.tiktok',
        image: '~/assets/img/icons/douyin.svg',
        // qrcode: '~/assets/img/footer/ic_qrcode_tiktok.png',
        link: 'https://www.tiktok.com/@sfexpress.sg?_t=ZS-8yJOIrO1jT0&_r=1',
      },
      {
        // 小红书 二维码
        name: 'gb_xhs',
        tips: 'common.media.gbsfuk',
        image: '~/assets/img/icons/gb_xhs.svg',
        // qrcode: '~/assets/img/footer/gb_xhs_2wm.svg',
        link: 'https://www.xiaohongshu.com/user/profile/66f3888b000000001d020268?xsec_token=YBuXy57k-7u3MQy6BWsC8f02bujOTgZ8XDi3hIaPArwts%3D&xsec_source=app_share&xhsshare=CopyLink&appuid=66f3888b000000001d020268&apptime=1753413924&share_id=e3426c2ebec04860ba92bed71a271492&share_channel=copy_link',
      },
    ],
    service: {
      product: [
        {
          name: 'common.country.sg',
          tel: '18003111111',
          telephone: '1800 311 1111',
          wApp: 'https://wa.link/ypa91t',
          whatsApp: '+6583237462',
          overseasTel: '+6566030630',
          overseasTelephone: '(+65) 66030630',
          list: [],
          time: [
            'relation.OfficeTimeSg1',
            'relation.OfficeTimeSg2',
            'relation.OfficeTimeSg3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            gjUtm: gjUtmConfig.sfIntlOsLogin.sg,
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  my: {
    shareList: shareList,
    shareSubTitle: 'modules.about.homePageTitles.followMy',
    shareSubList: [
      {
        name: 'my_facebook',
        tips: 'common.media.facebook',
        image: '~/assets/img/icons/facebook.svg',
        qrcode: '~/assets/img/footer/my_qrcode_facebook.png',
        // link: 'https://www.facebook.com/sfexpressmy/',
      },
      {
        name: 'my_ins',
        tips: 'common.media.instagram',
        image: '~/assets/img/icons/ins.svg',
        qrcode: '~/assets/img/footer/my_qrcode_ins.png',
        // link: 'https://www.instagram.com/sfexpressmy/',
      },
      {
        name: 'my_lingying',
        tips: 'common.media.linkedIn',
        image: '~/assets/img/icons/lingyin.svg',
        qrcode: '~/assets/img/footer/my_qrcode_lingying.png',
        // link: 'https://my.linkedin.com/company/sf-express-malaysia',
      },
    ],
    service: {
      product: [
        {
          name: 'common.country.my',
          tel: '1800183331',
          telephone: '1800 33 3333',
          list: [],
          time: [
            'relation.OfficeTimeMy1',
            // 'relation.OfficeTimeMy2',
            // 'relation.OfficeTimeMy3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.my,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  in: {
    shareList: shareList,
    // shareSubTitle: 'modules.about.homePageTitles.followMy',
    shareSubList: [
      // {
      //   name: 'my_facebook',
      //   tips: 'common.media.facebook',
      //   image: '~/assets/img/icons/facebook.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_facebook.png',
      //   // link: 'https://www.facebook.com/sfexpressmy/',
      // },
      // {
      //   name: 'my_ins',
      //   tips: 'common.media.instagram',
      //   image: '~/assets/img/icons/ins.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_ins.png',
      //   // link: 'https://www.instagram.com/sfexpressmy/',
      // },
      // {
      //   name: 'my_lingying',
      //   tips: 'common.media.linkedIn',
      //   image: '~/assets/img/icons/lingyin.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_lingying.png',
      //   // link: 'https://my.linkedin.com/company/sf-express-malaysia',
      // },
    ],
    service: {
      product: [
        {
          name: 'common.country.in',
          tel: '',
          telephone: '',
          telList: [
            {
              tel: '+91 8069078501',
              telephone: '+91 8069078501',
            },
            {
              tel: '+91 8069078502',
              telephone: '+91 8069078502',
            },
            {
              tel: '+91 8069078503',
              telephone: '+91 8069078503',  
            }
          ],
          list: [],
          time: [
            'relation.OfficeTimeIn1',
            // 'relation.OfficeTimeIn2',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.my,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  eu: {
    shareList: shareList,
    shareSubTitle: 'modules.about.homePageTitles.followEu',
    shareSubList: [
      // {
      //   name: 'my_facebook',
      //   tips: 'common.media.facebook',
      //   image: '~/assets/img/icons/facebook.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_facebook.png',
      //   // link: 'https://www.facebook.com/sfexpressmy/',
      // },
      // {
      //   name: 'my_ins',
      //   tips: 'common.media.instagram',
      //   image: '~/assets/img/icons/ins.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_ins.png',
      //   // link: 'https://www.instagram.com/sfexpressmy/',
      // },
      {
        name: 'my_lingying',
        tips: 'common.media.linkedIn',
        image: '~/assets/img/icons/lingyin.svg',
        // qrcode: '~/assets/img/footer/my_qrcode_lingying.png',
        link: 'https://www.linkedin.com/company/sf-express-europe',
      },
    ],
    service: {
      product: [
        {
          name: 'common.country.eu',
          // tel: '+31643249528',
          // telephone: '+31643249528',
          wApp: 'https://wa.me/31643249528/?text=Hello%EF%BC%81+This+is+your+dedicated+service+rep%21',
          whatsApp: '+31643249528',
          list: [],
          time: [
            'relation.OfficeTimeEu1',
            'relation.OfficeTimeEu2',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.eu,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  th: {
    shareList: shareList,
    shareSubList: [],
    service: {
      product: [
        {
          name: 'common.country.th',
          tel: '020971889',
          telephone: '020971889',
          list: [],
          time: [
            'relation.OfficeTimeTh1',
            'relation.OfficeTimeTh2',
            'relation.OfficeTimeTh3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.th,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
            href: allUrls.klnUrl + '/' + lang,
          },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  id: {
    shareList: shareList,
    shareSubList: [],
    service: {
      product: [
        {
          name: 'common.country.id',
          tel: '1500230',
          // telephone: '1500 230',
          list: [],
          time: [
            'relation.OfficeTimeNewId1',
            'relation.OfficeTimeNewId2',
            'relation.OfficeTimeId3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            gjUtm: gjUtmConfig.sfIntlOsLogin.id,
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  ph: {
    shareList: shareList,
    shareSubTitle: 'modules.about.homePageTitles.followPhilippines',
    shareSubList: [
      {
        name: 'ph_facebook',
        tips: 'common.media.facebook',
        image: '~/assets/img/icons/facebook.svg',
        link: 'https://www.facebook.com/sfexpress.philippines',
      },
      {
        name: 'ph_ins',
        tips: 'common.media.instagram',
        image: '~/assets/img/icons/ins.svg',
        link: 'https://www.instagram.com/sfexpress.philippines',
      },
      {
        name: 'ph_wechat',
        tips: 'common.media.wechat',
        image: '~/assets/img/icons/wx.svg',
        qrcode: '~/assets/img/footer/ph_qrcode_wechat.png',
      },
      {
        name: 'ph_whatsApp',
        tips: 'common.media.whatsApp',
        image: '~/assets/img/icons/whatsapp.png',
        qrcode: '~/assets/img/footer/ph_qrcode_whatsapp.png',
      },
      {
        name: 'ph_viber',
        tips: 'common.media.viber',
        image: '~/assets/img/icons/viber.png',
        qrcode: '~/assets/img/footer/ph_qrcode_viber.png',
      },
      {
        name: 'ph_xiaohongshu',
        tips: 'common.media.xiaohongshu',
        image: '~/assets/img/icons/xiaohongshu.png',
        qrcode: '~/assets/img/footer/ph_qrcode_xiaohongshu.png',
      },
    ],
    service: {
      product: [
        {
          name: 'common.country.ph',
          tel: '09985881865',
          telephone: '09985881865',
          list: [],
          time: ['relation.OfficeTimePh1', 'relation.OfficeTimePh2'], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            gjUtm: gjUtmConfig.sfIntlOsLogin.ph,
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  vn: {
    shareList: shareList,
    shareSubTitle: 'modules.about.homePageTitles.followVietnam',
    shareSubList: [
      {
        name: 'vn_wechat',
        tips: 'common.media.wechat',
        image: '~/assets/img/icons/wx.svg',
        qrcode: '~/assets/img/footer/vn_qrcode_wechat.jpg',
      },
      {
        name: 'vn_facebook',
        tips: 'common.media.facebook',
        image: '~/assets/img/icons/facebook.svg',
        qrcode: '~/assets/img/footer/vn_qrcode_fb.png',
      },
      {
        name: 'vn_tiktok',
        tips: 'common.media.tiktok',
        image: '~/assets/img/icons/douyin.svg',
        qrcode: '~/assets/img/footer/vn_qrcode_tk.png',
      },
      {
        name: 'vn_zalo',
        tips: 'common.media.zalo',
        image: '~/assets/img/icons/zalo.svg',
        qrcode: '~/assets/img/footer/vn_qrcode_zalo.png',
      },
    ],
    service: {
      product: [
        {
          name: 'modules.intro.menu.sfvn',
          tel: '1800 8110',
          telephone: '1800 8110',
          list: [],
          time: [
            'relation.OfficeTimeVn1',
            'relation.OfficeTimeVn2',
            // 'relation.OfficeTimeVn3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.vn,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  jp: {
    shareList: [
      {
        name: 'wechat',
        tips: 'common.media.wechat',
        image: '~/assets/img/icons/wx.svg',
        // qrcode: '~/assets/img/footer/ic_qrcode_wechat.jpg',
        qrcode: '~/assets/img/footer/jp_xhs_2wm.jpg',
      },
      {
        name: 'weibo',
        tips: 'common.media.weibo',
        image: '~/assets/img/icons/weibo.svg',
        qrcode: '~/assets/img/footer/ic_qrcode_weibo.png',
      },
      {
        name: 'douyin',
        tips: 'common.media.douyin',
        image: '~/assets/img/icons/douyin.svg',
        qrcode: '~/assets/img/footer/ic_qrcode_tiktok.png',
      },
      // {
      //   name: 'lingying',
      //   image: '~/assets/img/icons/lingyin.svg',
      //   qrcode: '~/assets/img/footer/ic_qrcode_lingying.png',
      // },
      {
        name: 'facebook',
        tips: 'common.media.facebook',
        image: '~/assets/img/icons/facebook.svg',
        qrcode: '~/assets/img/footer/ic_qrcode_facebook.png',
      },
      // {
      //   name: 'tw',
      //   image: require('~/assets/img/icons/tw.png'),
      //   qrcode: '~/assets/img/footer/ic_qrcode_tw.png',
      // },
      {
        name: 'youbube',
        tips: 'common.media.youtube',
        image: '~/assets/img/icons/youbube.svg',
        qrcode: '~/assets/img/footer/ic_qrcode_youbute.png',
      },
      {
        name: 'ins',
        tips: 'common.media.instagram',
        image: '~/assets/img/icons/ins.svg',
        qrcode: '~/assets/img/footer/ic_qrcode_ins.png',
      },
      // {
      //   name: 'tiktok',
      //   tips: 'common.media.tiktok',
      //   image: '~/assets/img/icons/douyin.svg',
      //   qrcode: '~/assets/img/footer/ic_qrcode_tiktok.png',
      // },
      {
        // 小红书 二维码
        name: 'gb_xhs',
        tips: 'common.media.xiaohongshu',
        image: '~/assets/img/icons/jp_xhs.svg',
        qrcode: '~/assets/img/footer/jp_xhs_qrcode.jpg',
        // link: 'https://www.instagram.com/sfexpressmy/',
      },
      {
        name: 'line',
        tips: 'common.media.line',
        image: '~/assets/img/footer/line.svg',
        qrcode: '~/assets/img/footer/ic_qrcode_line.png',
      },
    ],
    shareSubList: [
      // {
      //   // 小红书 二维码
      //   name: 'gb_xhs',
      //   // tips: 'common.media.gbsfuk',
      //   tips: '',
      //   image: '~/assets/img/icons/jp_xhs.png',
      //   qrcode: '~/assets/img/footer/jp_xhs_qrcode.jpg',
      //   // link: 'https://www.instagram.com/sfexpressmy/',
      // },
    ],
    service: {
      product: [
        {
          name: 'common.country.jp',
          tel: '03-6732-6631',
          telephone: '03-6732-6631',
          wApp: 'https://wa.link/ypa91t',
          kefu: nav.jp.kefu,
          whatsApp: '0120-683-683',
          list: [],
          time: [
            'relation.OfficeTimeJp1',
            'relation.OfficeTimeJp2',
            // 'relation.OfficeTimeSg3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'common.country.sf', // 国际官网
            href: '/cn/' + (lang === 'sc' ? 'sc' : 'en'),
            replace: true,
          },
          {
            name: 'navs.termsOfUse', // 使用条款
            href: '/support/termsOfUse',
          },
          {
            name: 'navs.personProtection', // 个人信息保护
            href: '/about/infoProtection',
            hidden: {
              lang: ['en', 'sc'],
            },
          },
          {
            name: 'navs.privacyPolicy', // 隐私政策
            href: '/support/privacyPolicy',
          },
          {
            name: 'navs.transactionLaw', // 基于特定商业交易法的展示
            href: '/about/businessLaw',
            hidden: {
              lang: ['en', 'sc'],
            },
          },
        ]
      },
    },
  },
  au: {
    shareList: shareList,
    shareSubTitle: 'modules.about.homePageTitles.followSf',
    shareSubList: [
      {
        name: 'my_facebook',
        tips: 'common.media.facebook',
        image: '~/assets/img/icons/facebook.svg',
        qrcode: '~/assets/img/footer/my_qrcode_facebook.png',
        // link: 'https://www.facebook.com/sfexpressmy/',
      },
      {
        name: 'my_ins',
        tips: 'common.media.instagram',
        image: '~/assets/img/icons/ins.svg',
        qrcode: '~/assets/img/footer/my_qrcode_ins.png',
        // link: 'https://www.instagram.com/sfexpressmy/',
      },
      {
        name: 'my_lingying',
        tips: 'common.media.linkedIn',
        image: '~/assets/img/icons/lingyin.svg',
        qrcode: '~/assets/img/footer/my_qrcode_lingying.png',
        // link: 'https://my.linkedin.com/company/sf-express-malaysia',
      },
    ],
    service: {
      product: [
        {
          name: 'navs.auCountry',
          tel: '1300148168',
          telephone: '1300148168',
          list: [],
          time: [
            'relation.OfficeTimeAu1',
            'relation.OfficeTimeAu2',
            'relation.OfficeTimeAu3',
          ],
        },
        {
          name: 'navs.nzCountry',
          tel: '+64 96660336',
          telephone: '+64 96660336',
          list: [],
          time: [
            'relation.OfficeTimeNz1',
            'relation.OfficeTimeNz2',
            'relation.OfficeTimeNz3',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.my,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  kr: {
    shareList: [
      ...shareList,
      {
        name: 'kr_kakao',
        tips: 'common.media.kakao',
        image: '~/assets/img/icons/kakao.svg',
        link: 'http://pf.kakao.com/_jhxcLT',
      },
      {
        name: 'kr-blog',
        tips: 'common.media.kr-blog',
        image: '~/assets/img/icons/kr-blog.svg',
        link: 'http://kr-blog.sf-express.com/',
      },
    ],
    shareSubTitle: 'modules.about.homePageTitles.followSf',
    shareSubList: [],
    service: {
      product: [
        {
          name: 'common.country.kr',
          tel: '0803931111',
          telephone: '080 393 1111',
          list: [],
          time: ['relation.OfficeTimeKr1', 'relation.OfficeTimeKr2'], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.my,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  gb: {
    shareList: shareList,
    // shareSubTitle: 'modules.about.homePageTitles.followMy',
    shareSubList: [
      // {
      //   name: 'my_facebook',
      //   // tips: 'common.media.facebook',
      //   image: '~/assets/img/icons/facebook.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_facebook.png',
      //   // link: 'https://www.facebook.com/sfexpressmy/',
      // },
      {
        // 小红书 二维码
        name: 'gb_xhs',
        tips: 'common.media.gbsfuk',
        image: '~/assets/img/icons/gb_xhs.svg',
        qrcode: '~/assets/img/footer/gb_xhs_2wm.svg',
        // link: 'https://www.instagram.com/sfexpressmy/',
      },
      // {
      //   name: 'my_ins',
      //   tips: 'common.media.instagram',
      //   image: '~/assets/img/icons/ins.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_ins.png',
      //   // link: 'https://www.instagram.com/sfexpressmy/',
      // },
      // {
      //   name: 'my_lingying',
      //   tips: 'common.media.linkedIn',
      //   image: '~/assets/img/icons/lingyin.svg',
      //   qrcode: '~/assets/img/footer/my_qrcode_lingying.png',
      //   // link: 'https://my.linkedin.com/company/sf-express-malaysia',
      // },
    ],
    service: {
      product: [
        {
          name: 'common.country.gb',
          tel: '95338',
          telephone: '95338',
          list: [],
          time: ['relation.OfficeTimeGb'], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.my,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
  us: {
    shareList: [],
    // shareSubTitle: 'modules.about.homePageTitles.followMy',
    shareSubList: [
      {
        // 小红书 二维码
        name: 'gb_xhs',
        tips: 'common.media.xiaohongshu',
        image: '~/assets/img/icons/gb_xhs.svg',
        qrcode: '~/assets/img/footer/us_xhs.png',
      //   link: 'https://www.xiaohongshu.com/user/profile/66f3888b000000001d020268?xsec_token=YBuXy57k-7u3MQy6BWsC8f02bujOTgZ8XDi3hIaPArwts%3D&xsec_source=app_share&xhsshare=CopyLink&appuid=66f3888b000000001d020268&apptime=1753413924&share_id=e3426c2ebec04860ba92bed71a271492&share_channel=copy_link',
      },
      {
        name: 'my_ins',
        tips: 'common.media.instagram',
        image: '~/assets/img/icons/ins.svg',
        qrcode: '~/assets/img/footer/my_qrcode_ins.png',
        // link: 'https://www.instagram.com/sfexpressmy/',
      },
      {
        name: 'my_lingying',
        tips: 'common.media.linkedIn',
        image: '~/assets/img/icons/lingyin.svg',
        qrcode: '~/assets/img/footer/my_qrcode_lingying_us.png',
      },
    ],

    service: {
      product: [
        {
          name: 'common.country.us',
          tel: '1（855）901-1133',
          telephone: '1（855）901-1133',
          list: [],
        },
        {
          name: 'common.country.us',
          tel: '1（289）203 2630',
          telephone: '1（289）203 2630',
          list: [],
          time: [
            // 'relation.OfficeTimeUS',
            'Mon-Fri 9:00-18:00',
            'Sat & Sun: Closed',
          ], // 营业时间
        },
      ],
      otherSite: (lang) => {
        return [
          {
            type: 'link',
            name: 'modules.about.homePageTitles.about_SF_Express', // 顺丰速运
            href:
              allUrls.sfExpressUrl + '/cn/' + (lang === 'sc' ? 'sc/' : 'en/'),
          },
          {
            type: 'link',
            gjUtm: gjUtmConfig.sfIntlOsLogin.us,
            name: 'modules.about.homePageTitles.businessSystem', // 顺丰国际下单系统
            href: allUrls.iuopGloballoginUrl_us,
          },
          {
            type: 'link',
            name: 'modules.about.homePageTitles.sfBuy', // 顺丰集运
            href: allUrls.sfbuyUrl,
          },
          // {
          //   name: 'navs.privacyPolicy', // 隐私政策
          //   // href: '/support/privacyPolicy',
          //   href: allUrls.privacyPolicy
          // },
          // {
          //   type: 'link',
          //   name: 'modules.about.homePageTitles.klnSystem', // 嘉里物流联网
          //   href: allUrls.klnUrl + '/' + lang,
          // },
        ]
      },
      customerUrl: allUrls.iuopGlobalCustomerUrl, // 商务合作
    },
  },
}

export default config
